import { CourseType } from "src/app/model/course-type";
import { TermType } from "src/app/model/term-type";
import { CourseHistorySchoolEnrollments } from "./course-history-school-enrollments";
import { CourseSection } from "src/app/model/course-section";
import { Region } from "src/app/model/region.model";

export class EditableCourseHistory {
	isEdit: boolean;
	isDelete?: boolean = false;
	courseHistory: CourseHistory;
}

export class CourseHistory {
      ID: number;
      STUDENTS_ID: number;
      SCHOOL_ENROLLMENTS_ID: number;
      SCHOOL_YEAR: string;
      COURSE_TYPES_ID: number;
      COURSE_SECTIONS_ID: number;
      TERM_TYPES_ID: number;
      COURSE_TITLE: string;
      SUBJECT_TITLE: string;
      CLOCK_HOURS: string;
      GRADE_TO_DATE: string;
      CREDITS_GRANTED: string;
      CREATED_BY: string;
      CREATED_DATE:  Date;
      SCHOOL_ENROLLMENT: CourseHistorySchoolEnrollments;
      COURSE_TYPE: CourseType;
      COURSE_SECTION: CourseSection;
      TERM_TYPE: TermType;
      REGION: Region;
    }
    